import React from "react";
import "./noConnection.css";
import BeatLoader from "react-spinners/BeatLoader";

import { useTheme } from "../../contexts/ThemeContext";

export default function NoConnection() {
  const { theme } = useTheme();

  return (
    <div className="no-connection-background">
      <div className="no-connection-box">
        اتصال شما به اینترنت قطع شد
        <BeatLoader color={"#151515"} loading={true} size={10} />
      </div>
    </div>
  );
}
